import axios from 'axios';
import z from 'zod';

import { SERVICEBASEURL } from 'enums/serviceBaseUrls';
import { Optional } from 'functions/promiseExtensions';

export const BodySchema = z.object({
	uploader: z.string(),
	dateStart: z.string(),
	dateEnd: z.string(),
});
export type Body = z.infer<typeof BodySchema>;

export function callApi(input: { body: Body; file: File }): Promise<Optional<Response>> {
	const url: string = `${SERVICEBASEURL.REPORT}/v1/files/upload`;

	const formData = new FormData();
	formData.append('inputFile', input.file);
	formData.append('uploader', input.body.uploader);
	formData.append('dateStart', input.body.dateStart);
	formData.append('dateEnd', input.body.dateEnd);

	return axios
		.post<Response>(url, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		})
		.toOptionalMapped((x) => x.data);
}

export async function callApiWithError(input: {
	body: Body;
	file: File;
}): Promise<{ success: boolean; data?: Response; error?: any }> {
	const url: string = `${SERVICEBASEURL.REPORT}/v1/files/upload`;

	const formData = new FormData();
	formData.append('inputFile', input.file);
	formData.append('uploader', input.body.uploader);
	formData.append('dateStart', input.body.dateStart);
	formData.append('dateEnd', input.body.dateEnd);

	try {
		const response = await axios.post<Response>(url, formData, {
			headers: {
				'Content-Type': 'multipart/form-data',
			},
		});
		return { success: true, data: response.data };
	} catch (error: any) {
		return { success: false, error };
	}
}

export type ReportFile = {
	url: string;
	state: 'PENDING' | 'READY' | 'FAILED';
	name: string;
	date: string | Date;
};

export type UploadResponse = {
	url: string;
	state: 'PENDING' | 'READY' | 'FAILED';
	name: string;
	date: string | Date;
};

type Response = UploadResponse;
